/**
 * Stroke icons (Lucide-style), same approach as SVGs in Contacts/Footer.
 * color via currentColor from parent CSS.
 */
const stroke = { fill: 'none', stroke: 'currentColor', strokeWidth: 2, strokeLinecap: 'round', strokeLinejoin: 'round' };

const paths = {
  savings: (
    <>
      <path d="M19 7V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v3" {...stroke} />
      <path d="M3 7h18v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" {...stroke} />
      <path d="M16 11a4 4 0 0 1-8 0" {...stroke} />
    </>
  ),
  preschool: (
    <>
      <path d="M3 21h18" {...stroke} />
      <path d="M5 21V7l7-4 7 4v14" {...stroke} />
      <path d="M9 9h.01" {...stroke} />
      <path d="M15 9h.01" {...stroke} />
      <path d="M9 13h6" {...stroke} />
    </>
  ),
  school: (
    <>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" {...stroke} />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" {...stroke} />
    </>
  ),
  tippo: (
    <>
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" {...stroke} />
    </>
  ),
  ovpo: (
    <>
      <path d="M22 10v6M2 10l10-6 10 6-10 6z" {...stroke} />
      <path d="M6 12v5c0 1.1 2.7 2 6 2s6-.9 6-2v-5" {...stroke} />
    </>
  ),
  palette: (
    <>
      <circle cx="13.5" cy="6.5" r=".5" fill="currentColor" stroke="none" />
      <circle cx="17.5" cy="10.5" r=".5" fill="currentColor" stroke="none" />
      <circle cx="8.5" cy="7.5" r=".5" fill="currentColor" stroke="none" />
      <circle cx="6.5" cy="12.5" r=".5" fill="currentColor" stroke="none" />
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.9 0 1.7-.1 2.5-.4" {...stroke} />
    </>
  ),
  dorms: (
    <>
      <path d="M3 9.5L12 3l9 6.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5z" {...stroke} />
      <path d="M9 21V12h6v9" {...stroke} />
    </>
  ),
  chart: (
    <>
      <path d="M3 3v18h18" {...stroke} />
      <path d="M18 17V9" {...stroke} />
      <path d="M13 17V5" {...stroke} />
      <path d="M8 17v-3" {...stroke} />
    </>
  ),
  gift: (
    <>
      <rect x="3" y="8" width="18" height="4" rx="1" {...stroke} />
      <path d="M12 8v13" {...stroke} />
      <path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7" {...stroke} />
      <path d="M7.5 8a2.5 2.5 0 0 1 0-5C9 3 12 8 12 8s3-5 4.5-5a2.5 2.5 0 0 1 0 5H7.5z" {...stroke} />
    </>
  ),
  'trending-up': (
    <>
      <path d="M23 6l-9.5 9.5-5-5L1 18" {...stroke} />
      <path d="M17 6h6v6" {...stroke} />
    </>
  ),
  shield: (
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" {...stroke} />
  ),
  scale: (
    <>
      <path d="M12 3v18" {...stroke} />
      <path d="M5 7h14" {...stroke} />
      <path d="M7 7l-3 6h6L7 7z" {...stroke} />
      <path d="M17 7l-3 6h6l-3-6z" {...stroke} />
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="4" width="18" height="18" rx="2" {...stroke} />
      <path d="M16 2v4M8 2v4M3 10h18" {...stroke} />
    </>
  ),
  calculator: (
    <>
      <rect x="4" y="2" width="16" height="20" rx="2" {...stroke} />
      <path d="M8 6h8M8 10h.01M12 10h.01M16 10h.01M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01" {...stroke} />
    </>
  ),
};

/** Map program id → icon key */
export const programIconById = {
  gons: 'savings',
  preschool: 'preschool',
  school: 'school',
  tippo: 'tippo',
  ovpo: 'ovpo',
  extra: 'palette',
  dorms: 'dorms',
};

export default function ProgramIcon({ name, size = 18, className = '' }) {
  const content = paths[name];
  if (!content) return null;

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden
      focusable="false"
    >
      {content}
    </svg>
  );
}
